import { useCallback } from "react";

import { useRouteModalHistoryState, useUserTriggeredModalsHistoryState } from "../history/use-modal-history-states";
import { useRouteModalsStore } from "../route-modals.store";
import { useUserTriggeredModalsStore } from "../user-triggered-modals.store";

export const useModalStateOperations = () => {
  const [, replaceTemporaryModalsState] = useUserTriggeredModalsHistoryState();
  const [, replaceRouteModalState] = useRouteModalHistoryState();

  const setRouteState = useRouteModalsStore((state) => state.setState);
  const setModalState = useUserTriggeredModalsStore((state) => state.setState);

  const setUserTriggeredModalState = useCallback(
    (id: string, value: unknown) => {
      setModalState(id, value);
      replaceTemporaryModalsState((temporaryModalsState) => {
        return temporaryModalsState.map((entry) => (entry.id === id ? { ...entry, state: value } : entry));
      });
    },
    [setModalState, replaceTemporaryModalsState],
  );

  const setRouteModalState = useCallback(
    (value: unknown) => {
      setRouteState(value);
      replaceRouteModalState({ state: value });
    },
    [setRouteState, replaceRouteModalState],
  );

  return { setUserTriggeredModalState, setRouteModalState };
};
